import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useLazyQuery, gql } from '@apollo/client';
import { useParams } from 'react-router-dom';

const StyledContainer = styled.div`
  margin-top: 10px;
  margin-bottom: 20px;
  text-align: center;
`;

export const MANDANT_BY_REGISTERID = gql`
  query mandantByRegisterId($mandantRegisterId: ID!) {
    mandantByRegisterId(mandantRegisterId: $mandantRegisterId) {
      _id
      name
    }
  }
`;

const MandantRegisterHeadline = () => {
  const { mandantName } = useMandantRegisterHeadlineState();

  return mandantName ? (
    <StyledContainer>
      <h5>Herzlich willkommen bei</h5>
      <h2>{mandantName}</h2>
    </StyledContainer>
  ) : null;
};

function useMandantRegisterHeadlineState() {
  const { mandantRegisterId } = useParams();
  let mandantName = null;

  const [getMandantByRegisterId, { data: mandantByRegisterIdData }] =
    useLazyQuery(MANDANT_BY_REGISTERID);

  if (
    mandantByRegisterIdData &&
    mandantByRegisterIdData.mandantByRegisterId &&
    mandantByRegisterIdData.mandantByRegisterId.name
  ) {
    mandantName = mandantByRegisterIdData.mandantByRegisterId.name;
  }

  useEffect(() => {
    if (mandantRegisterId) {
      getMandantByRegisterId({ variables: { mandantRegisterId } });
    }
  }, [mandantRegisterId, getMandantByRegisterId]);

  return { mandantName };
}

export default MandantRegisterHeadline;
